<template>
  <div v-if="hasPosMode && (isPosMode || isEventLive) && (assignedCount || unassignedCount)">
    <h2 class="group-heading">POS</h2>
    <div v-if="assignedCount > 0">
      <span class="item-text">
        <b>{{ assignedCount }}</b>
        assigned seats
      </span>
      <div v-for="(assignedPos, index) in assignedList" :key="index" class="flex gap-1">
        <div class="w-4 h-4" :style="{ 'background-color': assignedPos.pos.color }"></div>
        <span>
          <b>{{ assignedPos.count }}</b>
          - {{ assignedPos.pos.name }}
        </span>
      </div>
    </div>
    <div v-if="unassignedCount > 0" class="text-orange-600">
      <b>{{ unassignedCount }}</b>
      unassigned seats
    </div>
    <SMButton icon="cached" class="mt-2" type="primary" label=" Reload POS" @click.prevent.stop="refreshPosList" />
  </div>
</template>
<script lang="ts">
import eventbus from 'tiny-emitter/instance';
import { mapState, mapActions } from 'vuex';
import groupBy from 'lodash/groupBy';
import indexOf from 'lodash/indexOf';
import forOwn from 'lodash/forOwn';
import sumBy from 'lodash/sumBy';
import { EVENTSTATUS } from '@/constants';
import SMIcon from '../ui/SMIcon.vue';
import SMButton from '../ui/SMButton.vue';

export default {
  props: {
    isPosMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      elsCount: 0,
    };
  },
  computed: {
    ...mapState('pos', ['pos', 'assignedList', 'unassignedCount']),
    ...mapState('stats', ['gaSeats']),
    assignedCount: {
      get() {
        return sumBy(this.assignedList, (a) => a.count);
      },
    },
    isEventLive() {
      return this.$app.props.status === EVENTSTATUS.PUBLISHED;
    },
    hasPosMode() {
      return (
        indexOf(this.$app.props.options.modes, 'POS') !== -1 || indexOf(this.$app.props.options.modes, 'pos') !== -1
      );
    },
  },
  created() {
    eventbus.on('pos:ga-updated', this.onPosUpdate, this);
    eventbus.on('pos:set', this.onPosUpdate, this);
    eventbus.on('seatmap:updated', this.onPosUpdate, this);
    eventbus.on('seatmap:pos:updated', this.onPosUpdate, this);
    // seatmap mode change
    eventbus.on('seatmap:mode:changed', this.onPosUpdate, this);
    eventbus.on('seatmap:mode:changed', this.checkPos, this);
    this.onPosUpdate();
  },
  destroyed() {
    eventbus.off('pos:ga-updated', this.onPosUpdate, this);
    eventbus.off('pos:set', this.onPosUpdate, this);
    eventbus.off('seatmap:updated', this.onPosUpdate, this);
    eventbus.off('seatmap:pos:updated', this.onPosUpdate, this);
    // seatmap mode change
    eventbus.off('seatmap:mode:changed', this.onPosUpdate, this);
    eventbus.off('seatmap:mode:changed', this.checkPos, this);
  },
  methods: {
    ...mapActions('pos', ['addPosStats', 'updateAssignedList', 'changeUnassignedCount', 'loadPosList']),
    onPosUpdate() {
      const newAssignedList = this.getNewAssignedList();
      this.updateAssignedList(newAssignedList);
      const newUnassignedCount = this.getUnassignedCount();
      this.changeUnassignedCount(newUnassignedCount);
    },
    refreshPosList() {
      this.$app.refreshPosList(true);
    },
    getUnassignedCount() {
      return this.elsCount - sumBy(this.assignedList, (p) => p.count);
    },
    checkPos() {
      if (!this.$app.isShowPosColor() && !this.$app.isRecalculatePosColors()) {
        return;
      }
      const seatsAndTableSeats = this.$app.getFilteredSeats(this.$app.currentSection?.uuid);
      for (let idx = 0; idx < seatsAndTableSeats.length; idx++) {
        const seat = seatsAndTableSeats[idx];
        if (this.$app.isShowPosColor()) {
          seat.applyPosColor(this.$app.getPosColor(seat.pointOfSale));
        } else {
          seat.removePosColor();
        }
      }
    },
    getNewAssignedList() {
      const seatsAndTableSeats = this.$app.seatmap.getVisibleSeats(this.$app.currentSection?.uuid);
      const gaList = this.$app.getFilteredGa(this.isInsideZoneLayout);
      this.elsCount = seatsAndTableSeats.length + this.gaSeats;
      const elsGroupedByPos = groupBy(seatsAndTableSeats, (el) => el.attributes.posId);
      const newAssignedList = [];
      forOwn(elsGroupedByPos, (els, posId) => {
        if (Number.isNaN(+posId)) {
          return; //filter undefined and null
        }
        posId = posId.toString();
        const assignedPos = this.pos.find((p) => p.id && p.id.toString().trim() === posId.toString().trim());
        if (assignedPos) {
          newAssignedList.push({
            pos: assignedPos,
            count: els.length,
          });
        }
      });
      gaList
        .map((st) => st.pos)
        .forEach((posList) => {
          forOwn(posList, (val, key) => {
            if (!val) {
              return;
            }
            const foundPos = newAssignedList.find((a) => a.pos && a.pos.id.toString().trim() === key.toString().trim());
            if (foundPos) {
              foundPos.count += val;
            } else {
              const newPos = this.pos.find((p) => p.id && p.id.toString().trim() === key.toString().trim());
              if (!newPos) {
                return;
              }
              newAssignedList.push({
                pos: newPos,
                count: val,
              });
            }
          });
        });
      return newAssignedList;
    },
  },
  components: { SMIcon, SMButton },
};
</script>
